module.exports = __webpack_public_path__ + "static/media/calendar.e8af4b4b.svg";